import apiClient from "@/services/axios";

export async function put(dto) {
    var response = await apiClient.put(process.env.VUE_APP_CRM_API_BASE_URL + '/EngageEmail/EmailSignature', dto);
    if (response) {
        return response.data;
    }

    throw new Error("Unable to update email signature");
}
